import { Injectable } from '@angular/core';
import { EmojiData } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { EmojiUrlFn, IEmojiConfig, tofu } from './emoji-picker.interface';

@Injectable()
export class EmojiPickerService {
    getEmojiUrlFn(config: IEmojiConfig): EmojiUrlFn {
        let basePath = config.baseUrl;
        if (basePath.endsWith('/')) {
            basePath = basePath.slice(0, -1);
        }
        return (emoji: EmojiData | string | null) => {
            let unified: string | null = null;
            if (typeof emoji == 'string') {
                unified = emoji;
            }
            if (typeof emoji == 'object') {
                unified = emoji?.unified ?? null;
            }
            if (unified == null) {
                return tofu;
            }
            return basePath + `/${config.iconSet}/${config.sheetSize}/${unified.toLowerCase()}.png`;
        };
    }
}
